import { useQuery } from 'react-query';
import { BASE_API_URL } from '@env';
import { useUserStore } from '~providers/userStore/zustand';

export interface TransferEligibilityResponse {
  order_id: string;
  can_transfer: boolean;
  current_transfer_count: number;
  max_transfers_allowed: number;
  remaining_transfers: number;
  order_status: string;
  total_tickets: number;
  event_id: number;
}

export const useCheckTransferEligibility = (orderId: string) => {
  return useQuery<TransferEligibilityResponse, Error>(
    ['transferEligibility', orderId],
    async () => {
      const token = useUserStore.getState().token;
      const response = await fetch(`${BASE_API_URL}orders/${orderId}/can-transfer`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          Authorization: token,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to check transfer eligibility');
      }

      const data = await response.json();
      return data;
    },
    { 
      enabled: !!orderId,
      staleTime: 0, // Always fetch fresh data
      cacheTime: 0, // Don't cache the result
    },
  );
};